module.exports = __webpack_public_path__ + "static/contactBg-135b03d6811eec74a8651d32e39ac832.jpg";